/**
 * Normaliza o retorno do GET /sgo-imagem para o relatório.
 *
 * O campo `imagem` é um bytea que guarda o dataURL inteiro. Ele chega como o
 * Buffer serializado do Express (`{ type: 'Buffer', data: [...] }`) — e não como
 * string base64, apesar do `Buffer.from(..., 'base64')` da tela antiga sugerir
 * isso. As duas formas passam por aqui porque `Buffer.from` trata as duas, e o
 * teste cobre ambas para que ninguém "simplifique" isso e quebre o anexo.
 *
 * O endpoint devolve
 * responde `{ ok: 'Não existe fotos' }` — não uma lista vazia — quando não há
 * anexo. Anexo que não decodifica para um dataURL é descartado aqui: um arquivo
 * corrompido no banco não pode impedir a emissão do relatório inteiro.
 */
export default function preparaAnexos(resposta) {
  if (!Array.isArray(resposta)) return [];

  return resposta
    .map(item => {
      if (!item || !item.imagem) return null;

      let dataURL;
      try {
        dataURL = Buffer.from(item.imagem, 'base64').toString();
      } catch (erro) {
        return null;
      }
      if (!/^data:/.test(dataURL)) return null;

      const ehPdf = dataURL.indexOf('data:application/pdf') === 0;
      return {
        id: item.id,
        tipo: ehPdf ? 'pdf' : 'imagem',
        dataURL,
        nome: ehPdf ? `anexo-${item.id}.pdf` : undefined,
      };
    })
    .filter(Boolean);
}
